/*
   Possible conditions:
     "cartTotalMinimum": an int amount in cents
     "cartQuantityMinimum": an int amount of items in the cart
     "productInCart": a product variant id int
     "productPropertyInCart": a product variant ID int, and a property name and value string
     
*/

class ConditionManager {
    constructor(selector, conditions, options) {
        this.selector = selector;
        this.conditions = conditions;
        this.options = options
        window.conditionManagerisRemoving = false
        this.init()
    }

    query(selector) {
        return document.querySelector(selector)
    }

    errorCheck() {
        if (this.selector === undefined) {
            throw new Error('ConditionManager: selector is undefined')
        }
        if (this.conditions === undefined) {
            throw new Error('ConditionManager: conditions is undefined')
        }

        if (!document.querySelector(this.selector)) {
            throw new Error(`ConditionManager: selector ${this.selector} does not exist`)
        }
    }

    async considerRemoval() {
        console.log('Thinking about removing');
        if (window.conditionManagerisRemoving) return;
        console.log('Not already removing');

        if (this.conditionsMet < this.options.minimumNeededConditions) {
            const item = this.query(this.selector)

            // console.log(item)
            console.log('Considering removal from cart');
            if (!item) return
            const variantId = item.dataset.variantId
            window.conditionManagerIsRemoving = true;
            try {
                console.log('Trying to remove from cart');
                await removeFromCart(variantId)
                this.removeFromLocalStorage(variantId);
                window.conditionManagerIsRemoving = false;
            } catch (error) {
                console.log(error)
                window.conditionManagerIsRemoving = false;
            }
        }
    }

    removeFromLocalStorage(id) {
        let log = localStorage.getItem("freeGiftLog");
        let logArray;

        if (!log) {
            return;
        } else {
            logArray = JSON.parse(log);
        }

        let idStr = String(id);

        const index = logArray.findIndex(element => String(element) === idStr);

        if (index > -1) {
            logArray.splice(index, 1);
        }

        localStorage.setItem("freeGiftLog", JSON.stringify(logArray));
    }

    async conditionCartTotalMinimum() {
        const cart = await getCart()
        if (cart.total_price >= this.conditions.cartTotalMinimum) {
            return true
        }
        return false
    }

    async conditionProductsInCart() {
        const cart = await getCart();
        const cartItemIds = cart.items.map(item => item.variant_id.toString());

        const conditionMet = this.conditions.productInCart.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });

        return conditionMet;
    }

    async multiConditionProductsInCart() {
        const cart = await getCart();

        const cartItemIds = cart.items.map(item => item.variant_id.toString());
        const conditionOneMet = this.conditions.multiProductsInCart.buyVariantsList1.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });
        const conditionTwoMet = this.conditions.multiProductsInCart.buyVariantsList2.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });

        return conditionOneMet && conditionTwoMet

    }

    conditionStategies() {
        return {
            cartTotalMinimum: async () => {
                console.log('Trying cart total minimum');
                const conditionMet = await this.conditionCartTotalMinimum()
                if (conditionMet) {
                    this.conditionsMet++
                } else {
                    this.considerRemoval()
                }
            },
            productInCart: async () => {
                console.log('Trying product in cart');
                const conditionMet = await this.conditionProductsInCart();
                if (conditionMet) {
                    this.conditionsMet++;
                } else {
                    this.considerRemoval();
                }
            },
            multiProductsInCart: async () => {
                console.log('Trying multiproducts in cart');
                const conditionMet = await this.multiConditionProductsInCart()
                if (conditionMet) {
                    this.conditionsMet++;
                } else {
                    this.considerRemoval();
                }
            }
        }
    }

    checkConditions() {
        for (let key in this.conditionStategies()) {
            if (this.conditions[key]) {
                this.conditionStategies()[key]()
            }
        }
    }

    onInitCheck() {
        this.conditionsMet = 0
        this.checkConditions()
    }

    initListeners() {
        const checkoutButtons = document.querySelectorAll(this.options.checkoutButtonSelector)
        checkoutButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                this.checkConditions()
            })
        })
    }


    init() {
        this.onInitCheck()
        this.initListeners()
    }


}

